import { render, staticRenderFns } from "./QuoteTemplateSideMenu.vue?vue&type=template&id=9ccc232e"
import script from "./QuoteTemplateSideMenu.vue?vue&type=script&lang=js"
export * from "./QuoteTemplateSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ccc232e')) {
      api.createRecord('9ccc232e', component.options)
    } else {
      api.reload('9ccc232e', component.options)
    }
    module.hot.accept("./QuoteTemplateSideMenu.vue?vue&type=template&id=9ccc232e", function () {
      api.rerender('9ccc232e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quotetemplate/QuoteTemplateSideMenu.vue"
export default component.exports